import React, { useCallback } from 'react';
import WeatherSun from '@uber/base-icons/weather-sun';
import useAnalyticsFoStageToolBar from '../../../labelling/components/stage-toolbar/analytics/useAnalyticsForStageToolBar';
import { useImageSettings } from '../../hooks/use-image-settings';
import { CONTROL_TYPES } from './constants';
import SliderControl from './slider-control';
export const SELECTOR_IDS = {
  INCREASE_BRIGHTNESS: 'increase-brightness-button',
  DECREASE_BRIGHTNESS: 'decrease-brightness-button'
};
function BrightnessControl() {
  const [imageSettings, setImageSettings] = useImageSettings();
  const {
    brightness
  } = imageSettings;
  const {
    sendEventChangeControls
  } = useAnalyticsFoStageToolBar();
  const handleBrightness = (newValue: number) => {
    setImageSettings({
      ...imageSettings,
      brightness: newValue
    });
  };
  const onFinalChange = useCallback((value: number) => {
    sendEventChangeControls({
      action: CONTROL_TYPES.BRIGHTNESS,
      value: value.toString()
    });
  }, [sendEventChangeControls]);
  return <SliderControl sliderMax={200} sliderMin={0} title="Brightness" value={brightness} onChange={handleBrightness} onFinalChange={onFinalChange} attributes={{
    'data-selector-id': SELECTOR_IDS.INCREASE_BRIGHTNESS,
    'data-e2e-id': SELECTOR_IDS.INCREASE_BRIGHTNESS
  }}>
      <WeatherSun title="Brightness" />
    </SliderControl>;
}
export default BrightnessControl;